import { createSlice } from "@reduxjs/toolkit";

const initialState = {
 drawAbstacle: false,
 drawPolygon: false,
 polygonEdit: false,
 abstacleEdit: false,
 customCapacityCheck: false,
 lineNo: 0,
 roofAccordion: true,
 abstacleAccordion: false,
 xValue: 1,
 yValue: 1
};

export const designParameter = createSlice({
  name: "designParameter",
  initialState: initialState,
  reducers: {
    updateDesignParameter: (state, action) => {
      return { ...state, ...action.payload };
    },
    resetDesignParameter: (state, action) =>{
      return initialState
    }
  },
});

export const { updateDesignParameter, resetDesignParameter } = designParameter.actions;

export default designParameter.reducer;